module.exports = __webpack_public_path__ + "static/img/zidongjieting2.9e569b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zidongjieting2.png
// module id = v8ME
// module chunks = 24